"use client"

import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { useShoppingCart } from '@/src/context/shopping-cart/shopping-cart-context'
import { useTranslations } from 'next-intl'
import SvgBag from '@/src/assets/svgs/collection/bag.svg'
import Drawer from '../helpers/overlays/drawer/drawer'
import FixedBottomContainer from '../misc/fixed-bottom-container/fixed-bottom-container'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import FullShoppingCart from './full-shopping-cart/full-shopping-cart'
import { useGoogleAnalytics } from '@/src/context/google-analytics/google-analytics-context'
import { useSearchParams } from 'next/navigation'
import PathHelper from '@/src/helpers/path-helper'

export default function ShoppingCart() {
    const t = useTranslations('shopping-cart')
    const { shoppingCart, totalItemsPrice } = useShoppingCart()
    const { localMode } = useMerchant()
    const { viewCartGA } = useGoogleAnalytics()
    const searchParams = useSearchParams()

    const [drawer, setDrawer] = useState<boolean>(false)

    const hasItems = shoppingCart?.items && shoppingCart?.items.length > 0

    useEffect(() => {
        if (drawer && hasItems) {
            viewCartGA({
                currency: 'BRL',
                value: totalItemsPrice,
                items: shoppingCart.items.map((item) => ({
                    item_id: item.id,
                    item_name: item.name
                }))
            })
        }
    }, [drawer])

    useEffect(() => {
        const forceOpen = searchParams.get('openCart')

        if (forceOpen == 'true') {
            setDrawer(true)
            PathHelper.clearQueryParams()
        }
    }, [])

    if (shoppingCart) {
        return (
            <>
                {
                    drawer &&
                    <Drawer
                        openFrom='right'
                        isOpen={drawer}
                        onClose={() => setDrawer(false)}
                    >
                        <FullShoppingCart />
                    </Drawer>
                }
                {
                    ((hasItems) && !localMode) &&
                    <FixedBottomContainer id="shopping-cart-container" animationHandler={!drawer}>
                        <div onClick={() => setDrawer(true)} className={styles.container}>
                            <div className={styles.leftSide}>
                                <div className={styles.bagArea}>
                                    <div className={styles.bag}>
                                        <SvgBag className={styles.svgBag} />
                                    </div>
                                    <span className={styles.numberItems}>{shoppingCart.items.length}</span>
                                </div>
                                <span key={shoppingCart.items.length} className={styles.price}>{totalItemsPrice.toLocalePrice()}</span>
                            </div>
                            <div className={styles.rightSide}>
                                <span className={styles.seeBagTitle}>{t('seeBag')}</span>
                            </div>
                            <div key={shoppingCart.items.length} className={styles.glass} />
                        </div>
                    </FixedBottomContainer>
                }
            </>
        )
    }
    else {
        return <></>
    }
}
